//src/config.js

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const API_URL = 'http://121.185.41.7:5000';

export default API_URL;